module.exports = __webpack_public_path__ + "static/media/dti_logo_glyph.7ebab40f.svg";